module.exports = __webpack_public_path__ + "images/flag-01.png?d4f275f092270f0a1e3af2d526879969";